// Componente copiado de: src/paginas/avaliacao-desempenho/Elogios/Feed/Curtir/index.js
// Adaptado para comentários de ItemValor

import { useState } from 'react';
import { useIntl } from 'react-intl';
import Avatar from 'src/componentes/avatar';
import HoverCard from 'src/componentes/hover-card';
import Tooltip from 'src/componentes/tooltip';
import useAuth from 'src/hooks/useAuth';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
import LucideIcon from 'src/componentes/lucide-icon';

export default function CurtirComentarioButton({
  curtidas,
  comentarioId,
  endpoint,
}) {
  const { user } = useAuth();
  const intl = useIntl();
  const [curtido, setCurtido] = useState(
    curtidas?.find((e) => e.id == user?.id)
  );
  const [curtidasLocal, setCurtidasLocal] = useState(curtidas || []);

  const curtir = async () => {
    try {
      await http.post(endpoint, {
        comentarioId: comentarioId,
      });

      if (curtido) {
        setCurtidasLocal(curtidasLocal.filter((c) => c.id !== user.id));
      } else {
        setCurtidasLocal([
          ...curtidasLocal,
          {
            id: user.id,
            nome: user.nome,
            fotoArquivo: user.fotoArquivo,
          },
        ]);
      }

      setCurtido(!curtido);
    } catch (err) {
      errorHandler(err);
    }
  };

  const outrasCurtidas = curtidasLocal?.filter((e) => e.id !== user?.id);
  const totalCurtidas = outrasCurtidas?.length + (curtido ? 1 : 0);

  const quantidadeCurtidas = (
    <div className="ml-1 mr-4 cursor-default">
      {`${totalCurtidas} ${intl.formatMessage({
        id: totalCurtidas == 1 ? 'curtida' : 'curtidas',
      })}`}
    </div>
  );

  return (
    <div className="d-flex align-items-center">
      <Tooltip
        text={intl.formatMessage({ id: 'curtirComentario' })}
        placement="bottom"
        maxWidth="25vw"
      >
        <LucideIcon
          icon={curtido ? 'HeartFilled' : 'Heart'}
          size={20}
          cursor="pointer"
          color={curtido ? 'red' : '#1d7789'}
          colorHover={curtido ? 'red' : '#1d7789'}
          fill={curtido ? 'red' : 'white'}
          onClick={curtir}
          style={{ cursor: 'pointer' }}
        />
      </Tooltip>
      {outrasCurtidas?.length > 0 || curtido ? (
        <HoverCard
          placement="bottom"
          content={
            <div className="tw:max-h-37.5 tw:overflow-y-auto">
              {curtido && (
                <div className="tw:mb-1">
                  <Avatar
                    size={24}
                    id={`avatar-${user.id}`}
                    foto={user.fotoArquivo}
                    label={user.nome}
                  />
                </div>
              )}
              {outrasCurtidas?.map((item) => (
                <div className="tw:mb-1" key={item.id}>
                  <Avatar
                    size={24}
                    id={`avatar-${item.id}`}
                    foto={item.fotoArquivo}
                    label={item.nome}
                  />
                </div>
              ))}
            </div>
          }
        >
          {quantidadeCurtidas}
        </HoverCard>
      ) : (
        quantidadeCurtidas
      )}
    </div>
  );
}
